export const EMAIL_VALIDATION_REGEX =
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;

export const PUBLIC_FOLDER_REGEX = /\.(.*)$/;

export const MOBILE_USER_AGENTS_REGEX =
  /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone|playbook|silk/i;
